<template>
    <div class="circle-page">
        <!-- ========== 客户人群：查看人群 ========== -->
        <div class="sub-head">
            <el-button class="btn-ghost btn-sm" @click="goBack">← 返回人群管理</el-button>
            <div class="page-title">查看人群 <small>{{ curName }}</small></div>
        </div>
        <div class="meta-bar">
            <span v-for="(m, i) in metaList" :key="i" class="meta-item">{{ m[0] }}<b>{{ m[1] }}</b></span>
        </div>
        <div class="table-wrap">
            <el-table
                class="ref-table"
                :data="pageRows"
                v-loading="loading"
                :header-cell-style="{ background: '#FBFCFE', color: '#64748B', fontWeight: '700', fontSize: '14px' }"
                empty-text="暂无客户数据"
                style="width: 100%">
                <el-table-column label="客户" min-width="160">
                    <template #default="scope">
                        <div class="cust-cell">
                            <div class="cust-avatar">
                                <img v-if="scope.row.avatar" :src="scope.row.avatar" class="cust-avatar-img" alt="" />
                                <template v-else>{{ scope.row.name.charAt(0) }}</template>
                            </div>
                            <div class="cust-name">{{ scope.row.name }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="所属主体" min-width="110">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.subj }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="添加渠道" min-width="110">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.channel }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="添加时间" min-width="110">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.add }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="最近成交" min-width="140">
                    <template #default="scope">
                        <span class="muted-cell">{{ scope.row.deal }}</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="标签" min-width="160">
                    <template #default="scope">
                        <span v-for="t in scope.row.tags" :key="t" class="ctag">{{ t }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页（Element Plus 翻页组件） -->
            <pagechange :total="custTotal" :nowpage="custPage" @page_change="custPageChange" />
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
//导入分页组件（Element Plus 翻页组件封装）
import pagechange from '../components/pagechange.vue'
//导入查看人群人员列表接口
import { newgetcirclemembers } from '@/assets/js/common.js'

//路由参数（人群 id / 名称）
const route = useRoute()
//路由跳转
const router = useRouter()

/* ============== 工具 ============== */
function fmtInt(v) { return Math.round(v).toLocaleString('en-US'); }

/* ============== 状态 ============== */
//查看的人群名称（路由参数，无兜底）
const curName = ref(route.query.name || '')
const custPage = ref(1)
//列表加载中
const loading = ref(false)
//接口返回的客户列表
var customers = reactive([])

/* ============== 人群信息（列表上方统计，由人群管理列表携带） ============== */
//状态映射（与人群管理一致：0待计算 1计算中 2已完成 3计算失败；route.query.status 为字符串）
var CAL_STATUS = { 0: '待计算', 1: '计算中', 2: '已完成', 3: '计算失败' };
const metaList = computed(() => [
    ['人群分类', route.query.cat || '—'],
    ['覆盖人数', route.query.count != null && route.query.count !== '' ? fmtInt(Number(route.query.count)) + ' 人' : '—'],
    ['状态', CAL_STATUS[route.query.status] || '—'],
    ['创建人', route.query.owner || '—'],
    ['最近更新', route.query.last_calculated_at || '—']
]);

/* ============== 客户列表（Element Plus el-table + 分页） ============== */
const custTotalCount = ref(0)
//总条数
const custTotal = computed(() => custTotalCount.value);
//当前页数据（服务端分页，无兜底）
const pageRows = computed(() => customers);
//分页切换（服务端分页）
const custPageChange = (val) => { custPage.value = val; getMembers(); }

/* ============== 人员列表接口（newgetcirclemembers） ============== */
//GET /api/audience/members?id=&page=&page_size=；无兜底数据
const getMembers = () => {
    var id = route.query.id;
    if (id == null || id === '') return;
    loading.value = true;
    newgetcirclemembers({ id: id, page: custPage.value, page_size: 20 }).then((response) => {
        loading.value = false;
        if (response.data.msg.code == 0) {
            var d = response.data.data || {};
            var hasList = d.list !== undefined || Array.isArray(d);
            if (hasList) {
                customers.splice(0, customers.length);
                (d.list || (Array.isArray(d) ? d : [])).forEach(function (c) {
                    customers.push({
                        avatar: c.avatar || '',
                        name: c.name || c.customer_name || c.wx_name || '',
                        subj: c.corp_name || c.subject || c.subj || '',
                        channel: c.add_channel_label || c.channel || c.add_channel || '',
                        add: c.add_time || c.created_at || c.add || '',
                        deal: c.last_deal || c.deal || '',
                        tags: (c.labels || c.tags || []).map(function (t) { return t.title || t; })
                    });
                });
                custTotalCount.value = (d.total != null) ? d.total : ((d.pagination && d.pagination.total != null) ? d.pagination.total : customers.length);
            }
        }
    }).catch(() => {
        loading.value = false;
    })
}
//返回人群管理
const goBack = () => { router.push('/navkh/circlepeopledata'); }

/* ============== 初始化 ============== */
onMounted(() => {
    getMembers();
});
</script>

<style scoped>
.circle-page {
    --bg: #F7F8FC;
    --card: #ffffff;
    --primary: #4F46E5;
    --primary2: #7C3AED;
    --primarySoft: #A5B4FC;
    --red: #EF4444;
    --green: #10B981;
    --amber: #F59E0B;
    --text: #1E293B;
    --muted: #64748B;
    --grid: #EEF1F6;
    --border: #E8ECF3;
    --shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    --radius: 14px;
}

.container { max-width: none; margin: 0; padding: 0 0 20px; }
.page-title { font-size: 21px; font-weight: 800; margin: 4px 0 18px; }
.page-title small { font-weight: 500; color: var(--muted); font-size: 14px; margin-left: 10px; }

/* 按钮 */
.btn-ghost { background: #F1F3F9; color: var(--text); border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 600; cursor: pointer; font-size: 14px; }
.btn-ghost:hover { background: #E7EAF2; }
.btn-sm { padding: 6px 12px; font-size: 13.5px; border-radius: 8px; }
.btn-ghost:focus-visible { outline: none; }

/* 子页面头部 */
.sub-head { margin-bottom: 2px; }
.meta-bar { display: flex; flex-wrap: wrap; gap: 10px 26px; background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); padding: 14px 18px; margin-bottom: 16px; }
.meta-item { font-size: 14px; color: var(--muted); }
.meta-item b { color: var(--text); font-weight: 700; margin-left: 6px; }

/* 表格 */
.table-wrap { background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); padding: 6px 4px; overflow: hidden; }
.cust-cell { display: flex; align-items: center; gap: 10px; }
.cust-avatar { width: 32px; height: 32px; border-radius: 50%; background: linear-gradient(135deg, var(--primary), var(--primary2)); color: #fff; display: grid; place-items: center; font-weight: 700; font-size: 13px; flex-shrink: 0; overflow: hidden; }
.cust-avatar-img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
.cust-name { font-weight: 700; }
.muted-cell { color: var(--muted); }
.ctag { display: inline-block; font-size: 12px; font-weight: 600; padding: 2px 8px; border-radius: 999px; background: rgba(79, 70, 229, .08); color: var(--primary); margin-right: 5px; }

/* Element Plus 组件：参考页面样式适配 */
.ref-table {
    --el-table-border-color: #EEF1F6;
    --el-table-header-bg-color: #FBFCFE;
    --el-table-header-text-color: #64748B;
    --el-table-row-hover-bg-color: #F8FAFF;
    font-size: 14.5px;
}
.ref-table :deep(.el-table__cell) { padding: 13px 0; }
.ref-table :deep(.el-table .cell) { padding: 0 16px; }
.ref-table :deep(.el-table__header th) { font-weight: 700; font-size: 14px; }
.ref-table :deep(.el-table__empty-text) { color: var(--muted); font-size: 14px; padding: 34px 0; }
</style>
